import { Dispatch, SetStateAction, useState } from "react";
import { Contacto } from "../../../../../types/empresa";
import { DatosGeneralesText } from "../../../../../components/ui/DatosGeneralesText";
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';

interface Props {
    contacto: Contacto;
    setShowEdit: Dispatch<SetStateAction<boolean>>;
    showEdit: boolean;
    setContacto: Dispatch<SetStateAction<Contacto | null>>;
}

export function EmpresaContactos({ contacto, setShowEdit, showEdit, setContacto }: Props) {
    const [showEditButton, setShowEditButton] = useState(false);
    const iconSize = 20;

    return (
        <div
            onMouseEnter={() => setShowEditButton(true)}
            onMouseLeave={() => setShowEditButton(false)}>

            <div className="flex justify-between">
                <DatosGeneralesText 
                    icon={<Person2RoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Nombre: "}
                    text={contacto.nombre}/>

                <div className={`flex justify-end ${showEditButton ? "" : "hidden"} pr-[6px]`}>
                    <div 
                        className="hover:bg-gray-100 rounded-md w-[25px] h-[25px] flex justify-center items-center cursor-pointer">
                        {showEdit
                        ? 
                        <div
                        onClick={() => {
                            setContacto(null);
                            setShowEdit(false);
                        }}>
                            <ClearRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                        </div>
                        : 
                        <div
                            onClick={() => {
                                setContacto(contacto);
                                setShowEdit(true);
                            }}>
                            <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                        </div>
                        }
                    </div>
                </div>
                
            </div>

            <DatosGeneralesText 
                icon={<WorkRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Puesto: "}
                text={contacto.puesto}/>
            <DatosGeneralesText 
                icon={<EmailRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Correo: "}
                text={contacto.correo}/>
            <DatosGeneralesText 
                icon={<LocalPhoneRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Telefono empresa: "}
                text={contacto.telefonoEmpresa}/>
            <DatosGeneralesText 
                icon={<PhoneAndroidRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Telefono personal: "}
                text={contacto.telefonoPersonal}/>
            <DatosGeneralesText 
                icon={<ArticleRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Comentarios: "}
                text={contacto.comentarios}/>
        </div>
    );
}
